import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {StateService} from "@uirouter/angularjs";
import {Kontekst} from "felles/tjenester/Kontekst";
import {gettextCatalog} from "angular-gettext";
import {BrukerRessurs} from "felles/tjenester/ressurser/BrukerRessurs";
import {MeldingTilBruker} from "felles/tjenester/MeldingTilBruker";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";


export class BrukerBekreftEpostKontroller {
    static regNavn = "wm.bruker.BrukerBekreftEpostKontroller";
    static forInjisering = () => {
        return [
            regNavn.ng.ui.$stateParams,
            regNavn.ng.ui.$state,
            Kontekst.regNavn,
            BrukerRessurs.regNavn,
            MeldingTilBruker.regNavn,
            WebNavigasjon.regNavn,
            regNavn.gettext.gettextCatalog,
            BrukerBekreftEpostKontroller
        ]
    };

    constructor(private $stateParams: any,
                private $state: StateService,
                private kontekst: Kontekst,
                private brukerRes: BrukerRessurs,
                private meldingerTjeneste: MeldingTilBruker,
                private webNavigasjon: WebNavigasjon,
                private gettextCatalog: gettextCatalog) {
        const token = $stateParams.token;
        this.bekreftEpostadresse(token);
        this.webNavigasjon.gåTilStartsiden();
    }


    private bekreftEpostadresse(token: string) {
        this.brukerRes.bekreftEpostadresse(token).$promise
            .then(respons => {
                if (respons.validert) {
                    ///melding som vises når bruker har klikket på "bekreft din epostadresse" i velkommen til styreplan eposten
                    this.meldingerTjeneste.infomelding(this.gettextCatalog.getString('Takk for at du bekreftet e-postadressen din, da er vi trygge på at vi kan nå deg!'));
                    this.kontekst.relastBrukerOgGrupper(); //for å fjerne varsel om ikke-bekreftet epost
                } else {
                    ///melding som vises når bruker har klikket på "bekreft din epostadresse" i velkommen til styreplan eposten og tokenet er feil (skal normalt ikke forekomme)
                    this.meldingerTjeneste.infomelding(this.gettextCatalog.getString('Bekreftelse av e-post feilet.'));
                }
            });
    }

}
